import { SalesforceConnectionEdition } from '@modules/salesforce/models';
import { logErrorToSentry } from '@utils/common';
import { useLocation } from 'react-router-dom';

export const getConnectionEnv = (connection) => {
  if (connection?.isScratchOrg) {
    return SalesforceConnectionEdition.SCRATCH_ORG;
  }
  if (connection?.isSandbox == undefined) {
    return null;
  }
  return connection.isSandbox
    ? SalesforceConnectionEdition.SANDBOX
    : SalesforceConnectionEdition.PRODUCTION_OR_DEVELOPER;
};

export const getIsGlobalConnection = () => {
  const location = useLocation();
  return location.pathname.includes('settings/salesforce_connections');
};

//match and exclude patterns related to parameterised query. X|.....|
export const encodeParamerisedSOQLQuery = (query) => {
  const parameterisedQueryRegex =
    /@\|(.*?)\||\$\|(.*?)\||\*\|(.*?)\||~\|(.*?)\||!\|(.*?)\||%\|(.*?)\||&\|(.*?)\||((?:[^@$*~!%&]|%(?!\|)|!(?!\|)|&(?!\|)|[$*~](?!\|))+)/g;

  return query.replace(parameterisedQueryRegex, (match, ...groups) => {
    const specialPatterns = groups.slice(0, 7);
    const isSpecialPattern = specialPatterns.some((g) => g !== undefined);

    return isSpecialPattern ? match : encodeURIComponent(match); // Encode only non-matching parts
  });
};

export const decodeParameterisedSOQLQuery = (query) => {
  const parameterisedQueryRegex =
    /@\|(.*?)\||\$\|(.*?)\||\*\|(.*?)\||~\|(.*?)\||!\|(.*?)\||%\|(.*?)\||&\|(.*?)\||((?:[^@$*~!%&]|%(?!\|)|!(?!\|)|&(?!\|)|[$*~](?!\|))+)/g;

  if (!query) return '';

  return query.replace(parameterisedQueryRegex, (match, ...groups) => {
    const specialPatterns = groups.slice(0, 7);
    const isSpecialPattern = specialPatterns.some((g) => g !== undefined);

    return isSpecialPattern ? match : decodeURIComponent(match); // Encode only non-matching parts
  });
};
interface ErrorObject {
  error: string;
  [key: string]: any;
}

export const hasSensitiveInfo = (error: ErrorObject) => {
  if (!error?.error) return false;
  return /=(.*?)(,|$)/.test(error.error);
};

export const isInvalidGrant = (error: ErrorObject) => {
  if (!error?.error) return false;
  return error.error.toLowerCase().includes('invalid_grant');
};

export const isInvalidClient = (error: ErrorObject) => {
  if (!error?.error) return false;
  return error.error.toLowerCase().includes('invalid_client');
};

export const isInvalidClientId = (error: ErrorObject) => {
  if (!error?.error) return false;
  return error.error.toLowerCase().includes('invalid_client_id');
};

export const maskSensitiveInfo = (errorObject: string) => {
  if (!errorObject) return null;

  let maskedError;
  try {
    maskedError = JSON.parse(JSON.stringify(errorObject));
  } catch (error) {
    logErrorToSentry({ error });
    return null;
  }

  const maskString = (str: string) => {
    return str.replace(/=(.*?)(,|$)/g, (match, p1, p2) => {
      return `=${'*'.repeat(p1.length)}${p2}`;
    });
  };

  const traverseAndMask = (obj: ErrorObject) => {
    for (const key in obj) {
      if (typeof obj[key] === 'string') {
        obj[key] = maskString(obj[key]);
      } else if (typeof obj[key] === 'object' && obj[key] !== null) {
        traverseAndMask(obj[key]);
      }
    }
  };

  traverseAndMask(maskedError);
  return maskedError;
};
